export default __webpack_public_path__ + "dfd99763f2dd2dc75cb71f7dbd00c1bb.svg";